/**
 * Initialize the 'mfa' state.
 *
 * NOTE: this state is intentionally NOT persisted, the `mfaToken` is short lived
 * and must not be written to `localStorage`.
 *
 * @type {Object}
 */
const INITIAL_STATE = {
    // The methods the user is allowed to enroll into (`MFA_REQUIRED` responses).
    allowedMethods: [],
    // The error returned by the last verification attempt.
    error: null,
    // Is a verification request in flight?
    isVerifying: false,
    // The login credentials needed to complete the post sign in redirect.
    loginContext: {},
    // The MFA method the user has enrolled (`MFA_ENROLLED` responses).
    method: '',
    // The short lived token used to authorize the MFA APIs.
    mfaToken: '',
    // The `status` returned by the authenticate API.
    status: '',
};

export default INITIAL_STATE;
